export const SITE_URL = 'https://www.hznacs.com'
export const SITE_NAME = '湖州市工艺美术学会'
export const DEFAULT_TITLE = `${SITE_NAME} - 非遗传承、工艺美术大师、精品荟萃`
export const DEFAULT_DESCRIPTION =
  '湖州市工艺美术学会官网，汇聚工艺美术大师、非遗传承人，展示精品荟萃、学术研究、名家访谈等内容，推动湖州传统工艺美术发展。'
export const FOLK_CRAFT_COVER_URL = `${SITE_URL}/exhibition-folk-craft-cover.jpg`
